import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, Lock, ArrowRight } from "lucide-react";
import { api, imgUrl } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ThisWeek() {
  const { user } = useAuth();
  const pro = user.plan === "pro";
  const [plan, setPlan] = useState(undefined);
  useEffect(() => {
    if (pro) api.get("/plans/current").then(({ data }) => setPlan(data)).catch(() => setPlan(null));
  }, [pro]);

  if (!pro) {
    return (
      <Link to="/planner" className="panel p-5 mt-10 flex items-center gap-4 hover:border-[#9C4DDC]/60 transition-colors" data-testid="home-this-week-locked">
        <Lock size={18} className="text-[#9C4DDC]" strokeWidth={1.5} />
        <div className="flex-1"><p className="font-display text-lg">Weekly Planner</p><p className="text-xs muted">Plan a whole week of posts in one tap — Pro</p></div>
        <ArrowRight size={16} className="muted" />
      </Link>
    );
  }
  if (plan === undefined) return null;
  const total = plan?.slots.length || 0;
  const pct = total ? Math.round((plan.built / total) * 100) : 0;
  return (
    <Link to="/planner" className="panel p-5 mt-10 block hover:border-[#9C4DDC]/60 transition-colors fade-up" data-testid="home-this-week-card">
      <div className="flex items-center gap-4">
        {plan?.muse?.face_reference_url ? <img src={imgUrl(plan.muse.face_reference_url)} alt="" className="w-11 h-11 rounded-full object-cover border border-[#9C4DDC]/50" /> : <CalendarDays className="text-[#9C4DDC]" strokeWidth={1.5} />}
        <div className="flex-1 min-w-0">
          <p className="eyebrow">This week</p>
          <p className="font-display text-lg truncate">{plan ? `${plan.muse?.name}${plan.theme ? ` · ${plan.theme}` : ""}` : "No plan yet — plan her week"}</p>
        </div>
        {plan && <span className="font-display text-2xl text-[#9C4DDC]" data-testid="home-this-week-progress">{plan.built}/{total}</span>}
      </div>
      {plan && (
        <div className="h-[3px] rounded-full bg-[#F0EAF7] mt-4 overflow-hidden"><div className="h-full bg-[#9C4DDC] transition-[width] duration-700" style={{ width: `${pct}%` }} /></div>
      )}
      {plan && <p className="text-xs muted mt-2">{plan.built} of {total} built</p>}
    </Link>
  );
}
